import Backbone from "backbone";
import * as mustcache from "mustcache";

const EditProfileView = Backbone.View.extend({
  initialize: function (options) {
    this.options = options;
    this.render();
  },

  render: function () {
    const that = this;

    this.$el.html(
      mustcache.render("editProfile", {
        user: this.model.toJSON(),
      })
    );

    this.$el.find(".cancel").click(() => {
      that.options.finished();
    });

    this.$el.find("input[name=email]").keyup(() => {
      that.$el.find(".submitEmail").removeAttr("disabled");
    });

    const publicFields = ["username", "homepageURL", "location", "about"];
    this.$el
      .find(publicFields.map((name) => `[name=${name}]`).join(", "))
      .keyup(() => {
        that.$el.find(".submitPublic").removeAttr("disabled");
      });

    this.$el.find(".submitEmail").click(() => {
      const newEmail = that.$el.find("[name=email]").val();
      const oldEmail = this.model.get("email");

      if (
        prompt("Please enter the new email address again to confirm") !==
        newEmail
      ) {
        alert("Email addresses do not match");
        return;
      }

      that.model.save(
        {
          email: newEmail,
        },
        {
          patch: true,
          success: function () {
            if (that.options.finished) {
              that.options.finished();
            }
          },
          error: function () {
            that.model.set("email", oldEmail);
            alert(
              "That email address already exists, please choose a different one"
            );
          },
        }
      );
    });

    this.$el.find(".submitPublic").click(() => {
      const newUser = {
        username: that.$el.find("[name=username]").val(),
        homepageURL: that.$el.find("[name=homepageURL]").val(),
        location: that.$el.find("[name=location]").val(),
        about: that.$el.find("[name=about]").val(),
      };

      that.model.save(newUser, {
        patch: true,
        success: function () {
          if (that.options.finished) {
            that.options.finished();
          }
        },
        error: function () {
          alert("That username already exists, please choose a different one");
        },
      });
    });

    this.model.on("change", () => {
      that.render();
    });
  },
});

export default EditProfileView;
